import fbIcon from "../../images/social/fb.svg";
import liIcon from "../../images/social/li.svg";
import twIcon from "../../images/social/tw.svg";
import ytIcon from "../../images/social/yt.svg";
import igIcon from "../../images/social/ig.svg";
import { aboutLink, contactLink, faqLink, homepage, internshipLink, PrivacyPolicyLink, TermsAndConditionsLink } from "../../common/routes";

export const SocialIcons = [
  {
    url: "/",
    icon: fbIcon,
  },
  {
    url: "/",
    icon: liIcon,
  },
  {
    url: "/",
    icon: twIcon,
  },
  {
    url: "/",
    icon: ytIcon,
  },
  {
    url: "/",
    icon: igIcon,
  },
];

export const company = {
  title: "Company",
  items: [
    {
      url: homepage,
      text: "Home",
    },
    {
      url: aboutLink,
      text: "About Us",
    },
    {
      url: internshipLink,
      text: "Internships",
    },
    {
      url: "/",
      text: "Career",
    },
  ],
};

export const community = {
  title: "Community",
  items: [
    {
      url: TermsAndConditionsLink,
      text: "Terms",
    },
    {
      url: PrivacyPolicyLink,
      text: "Privacy",
    },
    {
      url: "/",
      text: "Campus Ambassador",
    },
    {
      url: "/",
      text: "Blogs",
    },
  ],
};

export const more = {
  title: "More",
  items: [
    {
      url: faqLink,
      text: "FAQ",
    },
    {
      url: contactLink,
      text: "Contact Us",
    },
  ],
};
